import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Simple from '../../components/page/Simple'

export default connect(null, null)(withTranslation()(Simple))
